module.exports = __webpack_public_path__ + "img/dashboard-dark.bc83a575.svg";